import { render, staticRenderFns } from "./AdminStudent.vue?vue&type=template&id=dfd11a40&"
import script from "./AdminStudent.vue?vue&type=script&lang=js&"
export * from "./AdminStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports